import React from 'react';
import { Typography } from "@material-ui/core"
import { Grid } from "@material-ui/core";
import Zahlungsweise from "./input/Zahlungsweise";
import InputSelbstbehalt from "./input/Selbstbehalt";
import Vs from "./input/Vs";


const Form: React.FC<{ disabled: boolean }> = ({ disabled }) => {
    return (

        <Grid container spacing={2} alignItems='center' style={{ transition: 'all, 0.5s', filter: disabled ? 'opacity(1)' : undefined }}>
            <Grid item>
                <Typography variant='body1' color='textPrimary' display='inline'>Ich bevorzuge eine</Typography>
            </Grid>
            <Grid item>
                <Zahlungsweise disabled={disabled} />
            </Grid>
            <Grid item>
                <InputSelbstbehalt disabled={disabled} />
            </Grid>
            <Grid item>
                <Vs disabled={disabled} />
            </Grid>
        </Grid>
    )
};

export default Form;